export default {
    text: 'text/html',
    image: 'image',
    button: 'button'
};